var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { variables } from '../../styles/variables';
;
export var LeftFrameStyled = styled(function (_a) {
    var opened = _a.opened, props = __rest(_a, ["opened"]);
    return React.createElement("div", __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-left: ", ";\n  transition: all 0.5s;\n  width: 70px;\n  height: calc(100vh - 70px);\n  top: 70px;\n  position: fixed;\n  background-color: ", ";\n  z-index: 3;\n"], ["\n  margin-left: ", ";\n  transition: all 0.5s;\n  width: 70px;\n  height: calc(100vh - 70px);\n  top: 70px;\n  position: fixed;\n  background-color: ", ";\n  z-index: 3;\n"])), function (props) { return props.opened ? 0 : '-70px'; }, variables.colorFrame);
export var UnorderedList = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 45px 0;\n  list-style: none;\n  text-align: center;\n  margin: 0 auto;\n"], ["\n  padding: 45px 0;\n  list-style: none;\n  text-align: center;\n  margin: 0 auto;\n"])));
export var Link = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  display: block;\n  height: 40px;\n"], ["\n  cursor: pointer;\n  display: block;\n  height: 40px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
